import { render, staticRenderFns } from "./LeagueSearchItem.vue?vue&type=template&id=35516ccb"
import script from "./LeagueSearchItem.vue?vue&type=script&lang=js"
export * from "./LeagueSearchItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports